import { trackEvent } from '@patrianna/analytics'
import { getCookie, nextTick } from '@patrianna/shared-utils'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import cx from 'classnames'
import Link from 'next/link'
import { useRouter } from 'next/navigation'

import ROUTES from 'config/routes.json'
import useGetDataFromLocalStorage from 'hooks/useLocalStorage'
import content from 'prismic-translates/common.json'
import dialogInviteFriends from 'prismic-translates/dialog-invite-friends.json'
import { trackSPPlacementInteracted } from 'src/analyticActions/common/trackPaymentSnowplow'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import {
  getIsAcceptedRulesForScUser,
  isAppInitializedSelector,
  sweepstakeEnabledSelector,
} from 'store/modules/appConfig/selectors'
import { openShopHandler } from 'store/modules/shop/actions'
import { getAcceptedSrVersionSelector, isLoggedInSelector } from 'store/modules/user/selectors'

import { useShouldRedirectToOtp } from '../utils'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content, dialogInviteFriends])

function ShopMobileLink() {
  const router = useRouter()
  const dispatch = useAppDispatch()
  const isAcceptedRulesForScUser = useAppSelector(getIsAcceptedRulesForScUser)
  const appInitialized = useAppSelector(isAppInitializedSelector)
  const loggedIn = useAppSelector(isLoggedInSelector)
  const isUserRegistered = useGetDataFromLocalStorage('IS_USER_REGISTERED', false)
  const isOtpRedirect = useShouldRedirectToOtp()
  const acceptedSrVersion = useAppSelector(getAcceptedSrVersionSelector)
  const sweepstakeEnabled = useAppSelector(sweepstakeEnabledSelector)
  const switchCurrencyModalCookie = Boolean(getCookie('SWITCH_CURRENCY_MODAL', document.cookie))
  const userShouldAcceptScRules = sweepstakeEnabled && (!acceptedSrVersion || switchCurrencyModalCookie)

  if (!appInitialized) {
    return <div className={cx(classes.root, !isAcceptedRulesForScUser && classes.disable)} />
  }

  const handleShopClick = () => {
    nextTick().then(() => {
      trackSPPlacementInteracted({
        paymentFlow: 'coin_store',
        placementName: 'cta_button',
        interactionName: t('buy'),
        placementTrigger: 'click_menu_button',
      })

      if (isOtpRedirect) {
        window.location.href = ROUTES.OTP
      }

      if (userShouldAcceptScRules) {
        window.location.href = ROUTES.HOME
      }

      if (isAcceptedRulesForScUser) {
        dispatch(openShopHandler(true, router.push))
      }
    })
  }

  const handleAuthLinkClick = () => {
    nextTick().then(() => {
      trackEvent(isUserRegistered ? 'bottom_menu_login_button_click' : 'bottom_menu_join_button_click')
    })
  }

  return loggedIn ? (
    <div className={cx(classes.root, !isAcceptedRulesForScUser && classes.disable)} onClick={handleShopClick}>
      <div className={classes.animatedBg} />
      <span className={classes.text} data-testid='footer-get-coins-button'>
        {t('buy')}
      </span>
    </div>
  ) : (
    <>
      <Link
        href={isUserRegistered ? ROUTES.LOGIN : ROUTES.REGISTER}
        prefetch={false}
        className={classes.root}
        onClick={handleAuthLinkClick}
      >
        <div className={classes.animatedBg} />
        <span className={classes.text}>{isUserRegistered ? t('login') : t('join')}</span>
      </Link>
    </>
  )
}

export default ShopMobileLink
